// Axios
import axios from 'axios';

// Configuration
import {
  BASE_URL,
  ORDER_SERVICE,
  SERVICE_VERSION,
  CAPABILITIES,
  VERSION
} from './configuration';

// Endpoint
import { ORDER_ENDPOINT } from './configuration/order-service';

// Utils
import { formatMessage } from '../utils/index';

//store
import store from '../store';

export const ORDER_SERVICE_URL = `${BASE_URL}/${ORDER_SERVICE}/${SERVICE_VERSION}`;

export const ORDER_SERVICE_CAPABILITIES_URL = `${BASE_URL}/${ORDER_SERVICE}/${CAPABILITIES}/${VERSION}`;

export const getOrderFulfilmentInvoice = (invoiceNumber, tenantId) => {
  return (dispatch) => {
    dispatch({
      type: 'SET_LOADER',
      payload: true
    });

    axios
      .get(
        `${ORDER_SERVICE_URL}/${ORDER_ENDPOINT.INVOICE}/${invoiceNumber}/${ORDER_ENDPOINT.DOWNLOAD}`,
        {
          headers: {
            'Content-Type': 'application/json',
            'X-tenant': tenantId
          },
          responseType: 'blob'
        }
      )
      .then((response) => {
        if (response.data) {
          const filename = 'invoice-{0}.pdf';
          const blob = new Blob([response.data], {
            type: response.headers['content-type']
          });
          const link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          link.download = formatMessage(filename, invoiceNumber);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
        dispatch({
          type: 'SET_LOADER',
          payload: false
        });
      })
      .catch(async (error) => {
        const text = await error.response.data.text();
        const data = JSON.parse(text);
        const errorObject = {
          data
        };
        dispatch({
          type: 'ERROR',
          error: errorObject
        });
        dispatch({
          type: 'SET_LOADER',
          payload: false
        });
      });
  };
};

export const getInvoiceDetails = (orderId, tenantId) => (dispatch) => {
  dispatch({
    type: 'SET_LOADER',
    payload: true
  });

  return axios
    .get(`${ORDER_SERVICE_URL}/${ORDER_ENDPOINT.INVOICE_HISTORY}`, {
      headers: {
        'Content-Type': 'application/json',
        'X-tenant': tenantId
      },
      params: {
        orderId: orderId
      }
    })
    .then((response) => {
      dispatch({
        type: 'SET_LOADER',
        payload: false
      });

      return response.data;
    })
    .catch((error) => {
      dispatch({
        type: 'ERROR',
        error: error.response
      });
      dispatch({
        type: 'SET_LOADER',
        payload: false
      });
    });
};

export const createCheckoutId = (reqPayload) => () => {
  return axios
    .post(
      `${ORDER_SERVICE_CAPABILITIES_URL}/${ORDER_ENDPOINT.CHECKOUT}`,
      reqPayload,
      {
        headers: {
          'Content-Type': 'application/json',
          'X-tenant':
            store.getState().UserServiceReducer?.csmTenants?.tenantId ??
            process.env.REACT_APP_SELLER_TENANT_ID,
          buyerUserId: reqPayload?.userDetails?.userId
        }
      }
    )
    .then((response) => {
      return response?.data;
    });
};

export const processAddressCheckout = (reqPayload) => () => {
  return axios
    .post(
      `${ORDER_SERVICE_URL}/${ORDER_SERVICE}/${ORDER_ENDPOINT.ADDRESS_CHECKOUT}`,
      {},
      {
        params: {
          checkoutId: reqPayload.checkoutId,
          dcsAddressId: reqPayload.dcsAddressId
        },
        headers: {
          'Content-Type': 'application/json',
          'X-tenant':
            store.getState().UserServiceReducer?.csmTenants?.tenantId ??
            process.env.REACT_APP_SELLER_TENANT_ID,
          buyerUserId: reqPayload?.buyerUserId
        }
      }
    )
    .then((response) => {
      return response;
    });
};

export const initiateOrderProcess = (reqPayload) => () => {
  return axios
    .post(
      `${ORDER_SERVICE_CAPABILITIES_URL}/${ORDER_ENDPOINT.INITIATE_ORDER_PROCESS}`,
      reqPayload,
      {
        headers: {
          'Content-Type': 'application/json',
          'X-tenant':
            store.getState().UserServiceReducer?.csmTenants?.tenantId ??
            process.env.REACT_APP_SELLER_TENANT_ID,
          buyerUserId: reqPayload?.userDetails?.userId
        }
      }
    )
    .then((response) => {
      return response?.data;
    });
};

export const updateCartProduct = (reqPayload) => (dispatch) => {
  dispatch({
    type: 'SET_LOADER',
    payload: true
  });
  return axios
    .put(`${ORDER_SERVICE_URL}/${ORDER_ENDPOINT.PRODUCT_CART}`, reqPayload, {
      headers: {
        'Content-Type': 'application/json',
        'X-tenant':
          store.getState().UserServiceReducer?.csmTenants?.tenantId ??
          process.env.REACT_APP_SELLER_TENANT_ID
      }
    })
    .then((response) => {
      dispatch({
        type: 'SET_LOADER',
        payload: false
      });
      return response?.data;
    })
    .catch((error) => {
      dispatch({
        type: 'ERROR',
        error: error.response
      });
      dispatch({
        type: 'SET_LOADER',
        payload: false
      });
    });
};

export const getCartProduct = (buyerUserId) => (dispatch) => {
  dispatch({
    type: 'SET_LOADER',
    payload: true
  });
  return axios
    .get(`${ORDER_SERVICE_URL}/${ORDER_ENDPOINT.PRODUCT_CART}`, {
      headers: {
        'Content-Type': 'application/json',
        'X-tenant':
          store.getState().UserServiceReducer?.csmTenants?.tenantId ??
          process.env.REACT_APP_SELLER_TENANT_ID
      },
      params: {
        buyerUserId: buyerUserId
      }
    })
    .then((response) => {
      dispatch({
        type: 'SET_LOADER',
        payload: false
      });
      return response?.data;
    })
    .catch((error) => {
      dispatch({
        type: 'ERROR',
        error: error.response
      });
      dispatch({
        type: 'SET_LOADER',
        payload: false
      });
    });
};

export const deleteCartProducts = (productCartId, buyerUserId) => (dispatch) => {
  dispatch({
    type: 'SET_LOADER',
    payload: true
  });
  return axios
    .delete(`${ORDER_SERVICE_URL}/${ORDER_ENDPOINT.PRODUCT_CART}`, {
      headers: {
        'Content-Type': 'application/json',
        'X-tenant':
          store.getState().UserServiceReducer?.csmTenants?.tenantId ??
          process.env.REACT_APP_SELLER_TENANT_ID
      },
      params: {
        buyerUserId: buyerUserId,
        productCartId: productCartId
      }
    })
    .then(() => {
      dispatch({
        type: 'SET_LOADER',
        payload: false
      });
    })
    .catch((error) => {
      dispatch({
        type: 'ERROR',
        error: error.response
      });
      dispatch({
        type: 'SET_LOADER',
        payload: false
      });
    });
};
